<template>
    <div style="position: relative; background-color: inherit;" class="tiptap">
        <div v-if="!readonly && menu_type == 'bubble'">
            <editor-menu-bubble :editor="editor" :keep-in-bounds="true" v-slot="{ commands, isActive, menu }">
                <div
                    class="menububble"
                    :class="{ 'active': menu.isActive }"
                    :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`"
                >
                    <b-button-group>
                        <button
                            v-if="!menu_items || menu_items && menu_items.includes('bold')"
                            type="button"
                            class="menububble__button"
                            :class="{ 'active': isActive.bold() }"
                            content="Bold"
                            v-tippy="{placement: 'top'}"
                            @click="commands.bold"
                        >
                            <font-awesome-icon :icon="['fas', 'bold']" />
                        </button>
                        <button
                            v-if="!menu_items || menu_items && menu_items.includes('italic')"
                            type="button"
                            class="menububble__button"
                            :class="{ 'active': isActive.italic() }"
                            content="Italic"
                            v-tippy="{placement: 'top'}"
                            @click="commands.italic"
                        >
                            <font-awesome-icon :icon="['fas', 'italic']" />
                        </button>
                        <button
                            v-if="!menu_items || menu_items && menu_items.includes('underline')"
                            type="button"
                            class="menububble__button"
                            :class="{ 'active': isActive.underline() }"
                            content="Underline"
                            v-tippy="{placement: 'top'}"
                            @click="commands.underline"
                        >
                            <font-awesome-icon :icon="['fas', 'underline']" />
                        </button>
                        <button
                            v-if="!menu_items || menu_items && menu_items.includes('bullet_list')"
                            type="button"
                            class="menububble__button"
                            :class="{ 'active': isActive.bullet_list() }"
                            content="Bullet List"
                            v-tippy="{placement: 'top'}"
                            @click="commands.bullet_list"
                        >
                            <font-awesome-icon :icon="['fas', 'list-ul']" />
                        </button>
                        <button
                            v-if="!menu_items || menu_items && menu_items.includes('ordered_list')"
                            type="button"
                            class="menububble__button"
                            :class="{ 'active': isActive.ordered_list() }"
                            content="Ordered List"
                            v-tippy="{placement: 'top'}"
                            @click="commands.ordered_list"
                        >
                            <font-awesome-icon :icon="['fas', 'list-ol']" />
                        </button>
                        <button
                            v-if="menu_items && menu_items.includes('highlight')"
                            variant="light"
                            class="menububble__button text-danger"
                            :class="{ 'active': isActive.highlight_mark() }"
                            content="Highlight"
                            v-tippy="{placement: 'top'}"
                            @click="commands.highlight_mark()"
                        >
                            <font-awesome-icon :icon="['fas', 'highlighter']" />
                        </button>
                    </b-button-group>
                </div>
            </editor-menu-bubble>
        </div>
        <div v-else-if="!readonly && !menu_type || menu_type && menu_type == 'menu_bar'">
            <editor-menu-bar
                :editor="editor"
                v-slot="{ commands, isActive, getMarkAttrs, focused }"
            >
                <div class="menu_items mb-1" :class="{'is-focused': focused}">
                    <div class="d-flex">
                        <div>
                            <b-btn-group class='ml-1 btn-group-vertical'>
                                <div>
                                    <button
                                        class="btn btn-sm active"
                                        variant="light"
                                        content="Undo"
                                        v-tippy="{placement: 'top'}"
                                        @click="commands.undo"
                                        >
                                        <font-awesome-icon :icon="['far', 'undo']" />
                                    </button>
                                </div>
                                <div>
                                    <button
                                        class="btn btn-sm"
                                        variant="light"
                                        content="Redo"
                                        v-tippy="{placement: 'top'}"
                                        @click="commands.redo"
                                        >
                                        <font-awesome-icon :icon="['far', 'redo']" />
                                    </button>
                                </div>
                            </b-btn-group>
                            <b-btn-group class='ml-1 btn-group-vertical' :class="{'is-focused': focused, 'readonly': readonly || editing_html}">
                                <div>
                                    <b-btn
                                        v-if="!menu_items || menu_items && menu_items.includes('bold')"
                                        variant="light"
                                        class="btn btn-sm"
                                        :class="{ 'active': isActive.bold() }"
                                        @click="commands.bold"
                                    >
                                        <font-awesome-icon :icon="['far', 'bold']" />
                                    </b-btn>
                                    <b-btn
                                        v-if="!menu_items || menu_items && menu_items.includes('italic')"
                                        class="btn btn-sm"
                                        variant="light"
                                        :class="{ 'active': isActive.italic() }"
                                        @click="commands.italic"
                                    >
                                        <font-awesome-icon :icon="['far', 'italic']" />
                                    </b-btn>
                                    <b-btn
                                        v-if="!menu_items || menu_items && menu_items.includes('underline')"
                                        variant="light"
                                        class="btn btn-sm"
                                        :class="{ 'active': isActive.underline() }"
                                        @click="commands.underline"
                                    >
                                        <font-awesome-icon :icon="['far', 'underline']" />
                                    </b-btn>
                                    <b-btn
                                        v-if="!menu_items || menu_items && menu_items.includes('bullet_list')"
                                        variant="light"
                                        class="btn btn-sm"
                                        :class="{ 'active': isActive.bullet_list() }"
                                        @click="commands.bullet_list"
                                    >
                                        <font-awesome-icon :icon="['far', 'list-ul']" />
                                    </b-btn>
                                    <b-btn
                                        v-if="!menu_items || menu_items && menu_items.includes('ordered_list')"
                                        variant="light"
                                        class="btn btn-sm"
                                        :class="{ 'active': isActive.ordered_list() }"
                                        @click="commands.ordered_list"
                                    >
                                        <font-awesome-icon :icon="['far', 'list-ol']" />
                                    </b-btn>
                                </div>
                                <div>
                                    <b-btn
                                        v-if="menu_items && menu_items.includes('paragraph_alignment')"
                                        variant="light"
                                        class="btn btn-sm"
                                        @click="alignParagraph('left')"
                                        content="Text Left"
                                        v-tippy="{placement: 'top'}"
                                    >
                                        <font-awesome-icon :icon="['far', 'align-left']" />
                                    </b-btn>
                                    <b-btn
                                        v-if="menu_items && menu_items.includes('paragraph_alignment')"
                                        variant="light"
                                        class="btn btn-sm"
                                        @click="alignParagraph('center')"
                                        content="Text Center"
                                        v-tippy="{placement: 'top'}"
                                    >
                                        <font-awesome-icon :icon="['far', 'align-center']" />
                                    </b-btn>
                                    <b-btn
                                        v-if="menu_items && menu_items.includes('paragraph_alignment')"
                                        variant="light"
                                        class="btn btn-sm"
                                        @click="alignParagraph('right')"
                                        content="Text Right"
                                        v-tippy="{placement: 'top'}"
                                    >
                                        <font-awesome-icon :icon="['far', 'align-right']" />
                                    </b-btn>
                                    <b-btn
                                        v-if="menu_items && menu_items.includes('horizontal_rule')"
                                        variant="light"
                                        class="btn btn-sm"
                                        content="Horizontal Rule"
                                        v-tippy="{placement: 'left'}"
                                        @click="addHorizontalRule"
                                    >
                                        <font-awesome-icon :icon="['far', 'horizontal-rule']" />
                                    </b-btn>
                                </div>
                            </b-btn-group>
                            <b-btn-group
                                class='ml-1 btn-group-vertical'
                                :class="{'is-focused': focused, 'readonly': readonly || editing_html}"
                            >
                                <div>
                                    <b-btn
                                        v-if="menu_items && menu_items.includes('blank')"
                                        variant="light"
                                        @click="addBlank"
                                        content="Insert Blank"
                                        v-tippy="{placement: 'top'}"
                                    >
                                        <font-awesome-icon :icon="['far', 'horizontal-rule']" />
                                    </b-btn>
                                    <b-btn
                                        v-if="menu_items && menu_items.includes('image')"
                                        variant="light"
                                        class="btn btn-sm"
                                        content="Add SBP Image"
                                        v-tippy="{placement: 'top'}"
                                        @click="addSbpImage"
                                    >
                                        SBP
                                    </b-btn>
                                </div>
                                <div>
                                    <b-btn
                                        v-if="menu_items && menu_items.includes('interactive_media_link')"
                                        variant="light"
                                        class="btn btn-sm"
                                        content="Interactive Media Link"
                                        v-tippy="{placement: 'top'}"
                                        @click="addInteractiveMediaLink"
                                    >
                                        <font-awesome-icon :icon="['far', 'photo-video']" />
                                    </b-btn>
                                </div>
                            </b-btn-group>
                            <b-btn-group
                                class='ml-1'
                                :class="{'is-focused': focused, 'readonly': readonly || editing_html}"
                            >
                            </b-btn-group>
                            <b-btn-group class='ml-1 btn-group-vertical'>
                                <div>
                                    <b-btn
                                        v-if="menu_items && menu_items.includes('highlight')"
                                        variant="light"
                                        style="color: rgba(209, 0, 7, 1.00)"
                                        class="btn btn-sm"
                                        :class="{ 'active': isActive.highlight_mark() }"
                                        content="Red Text"
                                        v-tippy="{placement: 'left'}"
                                        @click="commands.highlight_mark()"
                                    >
                                        <font-awesome-icon :icon="['far', 'highlighter']" />
                                    </b-btn>
                                    <b-btn
                                        v-if="menu_items && menu_items.includes('highlight_orange')"
                                        variant="light"
                                        style="color:rgba(199, 80, 0, 1.00)"
                                        class="btn btn-sm"
                                        :class="{ 'active': isActive.highlight_mark_orange() }"
                                        content="Orange Text"
                                        v-tippy="{placement: 'bottom'}"
                                        @click="commands.highlight_mark_orange({new_color: 'orange'})"
                                    >
                                        <font-awesome-icon :icon="['far', 'highlighter']" />
                                    </b-btn>
                                    <b-btn
                                        v-if="menu_items && menu_items.includes('highlight_blue')"
                                        variant="light"
                                        style="color: rgba(49, 57, 150, 1.00)"
                                        class="btn btn-sm"
                                        :class="{ 'active': isActive.highlight_mark_blue() }"
                                        content="Blue Text"
                                        v-tippy="{placement: 'right'}"
                                        @click="commands.highlight_mark_blue({new_color: 'blue'})"
                                    >
                                        <font-awesome-icon :icon="['far', 'highlighter']" />
                                    </b-btn>
                                    <b-btn
                                        v-if="menu_items && menu_items.includes('highlight_teal')"
                                        variant="light"
                                        style="color: rgba(32, 129, 141, 1)"
                                        class="btn btn-sm"
                                        :class="{ 'active': isActive.highlight_mark_teal() }"
                                        content="Teal Text"
                                        v-tippy="{placement: 'top'}"
                                        @click="commands.highlight_mark_teal({new_color: 'teal'})"
                                    >
                                        <font-awesome-icon :icon="['far', 'highlighter']" />
                                    </b-btn>
                                </div>
                                <div>
                                    <b-btn
                                        v-if="menu_items && menu_items.includes('highlight_green')"
                                        variant="light"
                                        style="color: rgba(24, 124, 24, 1.00)"
                                        class="btn btn-sm"
                                        :class="{ 'active': isActive.highlight_mark_green() }"
                                        content="Green Text"
                                        v-tippy="{placement: 'top'}"
                                        @click="commands.highlight_mark_green({new_color: 'green'})"
                                    >
                                        <font-awesome-icon :icon="['far', 'highlighter']" />
                                    </b-btn>
                                    <b-btn
                                        v-if="menu_items && menu_items.includes('highlight_pink')"
                                        variant="light"
                                        style="color: rgba(205, 50, 138, 1)"
                                        class="btn btn-sm"
                                        :class="{ 'active': isActive.highlight_mark_pink() }"
                                        content="Pink Text"
                                        v-tippy="{placement: 'top'}"
                                        @click="commands.highlight_mark_pink({new_color: 'pink'})"
                                    >
                                        <font-awesome-icon :icon="['far', 'highlighter']" />
                                    </b-btn>
                                    <b-btn
                                        v-if="menu_items && menu_items.includes('highlight_purple')"
                                        variant="light"
                                        style="color: rgba(108, 88, 142, 1)"
                                        class="btn btn-sm"
                                        :class="{ 'active': isActive.highlight_mark_purple() }"
                                        content="Purple Text"
                                        v-tippy="{placement: 'top'}"
                                        @click="commands.highlight_mark_purple({new_color: 'purple'})"
                                    >
                                        <font-awesome-icon :icon="['far', 'highlighter']" />
                                    </b-btn>
                                    <b-btn
                                        v-if="menu_items && menu_items.includes('highlight_black')"
                                        variant="light"
                                        style="color: black"
                                        class="btn btn-sm"
                                        :class="{ 'active': isActive.highlight_mark_black() }"
                                        content="Black Text"
                                        v-tippy="{placement: 'top'}"
                                        @click="commands.highlight_mark_black({new_color: 'black'})"
                                    >
                                        <font-awesome-icon :icon="['far', 'highlighter']" />
                                    </b-btn>

                                    <b-btn
                                        v-if="menu_items && menu_items.includes('edit_html')"
                                        class="btn btn-sm"
                                        :class="{'active': editing_html}"
                                        variant="light"
                                        content="Edit HTML"
                                        v-tippy="{placement: 'top'}"
                                        @click="editHTML"
                                    >
                                        <font-awesome-icon :icon="['far', 'code']" />
                                    </b-btn>
                                </div>

                                <b-btn
                                    v-if="menu_items && menu_items.includes('hot_text')"
                                    variant="light"
                                    @click="addHotText(true)"
                                    :disabled="hotTextCorrectDisabled"
                                    content="Insert Correct Hot Text"
                                    v-tippy="{placement: 'right'}"
                                >
                                    <font-awesome-icon class="text-success" :icon="['far', 'check']" />
                                </b-btn>
                                <b-btn
                                    v-if="menu_items && menu_items.includes('hot_text')"
                                    variant="light"
                                    @click="addHotText(false)"
                                    content="Insert Incorrect Hot Text"
                                    v-tippy="{placement: 'right'}"
                                >
                                    <b class="text-danger">X</b>
                                </b-btn>
                            </b-btn-group>

                            <b-btn-group
                                class='ml-1'
                                :class="{'is-focused': focused, 'readonly': readonly}"
                            >

                            </b-btn-group>

                            <b-btn-group v-if="!isWalkthrough && !exclude_table" :class="{'is-focused': focused, 'readonly': readonly || editing_html}">
                                <b-btn-group class='ml-1 btn-group-vertical'>
                                    <b-btn
                                        variant="light"
                                        content="Add Table"
                                        v-tippy="{placement: 'top'}"
                                        class="menubar__button btn btn-sm"
                                        @click="commands.createTable({rowsCount: 3, colsCount: 3, withHeaderRow: false })"
                                    >
                                        <font-awesome-icon :icon="['far', 'table']" />
                                    </b-btn>
                                    <b-btn
                                        v-if="isActive.table()"
                                        variant="light"
                                        content="Delete Table"
                                        v-tippy="{placement: 'top'}"
                                        class="menubar__button mt-1 mr-1 btn btn-sm"
                                        @click="commands.deleteTable"
                                    >
                                        <font-awesome-icon style="color: red;" :icon="['far', 'table']" />
                                    </b-btn>
                                </b-btn-group>

                                <span v-if="isActive.table()">
                                    <b-btn-group class='ml-1 btn-group-vertical'>
                                        <div>
                                            <b-btn
                                                variant="light"
                                                content="Add Column Before"
                                                v-tippy="{placement: 'top'}"
                                                class="menubar__button mt-1 mr-1 btn btn-sm"
                                                @click="commands.addColumnBefore"
                                            >
                                                + Col Before
                                            </b-btn>
                                            <b-btn
                                                variant="light"
                                                content="Add Column After"
                                                v-tippy="{placement: 'top'}"
                                                class="menubar__button mt-1 mr-1 btn btn-sm"
                                                @click="commands.addColumnAfter"
                                            >
                                                + Col After
                                            </b-btn>
                                            <b-btn
                                                variant="light"
                                                content="Delete Column"
                                                v-tippy="{placement: 'top'}"
                                                class="menubar__button mt-1 mr-1 btn btn-sm"
                                                @click="commands.deleteColumn"
                                            >
                                                - Col
                                            </b-btn>
                                        </div>
                                        <div>
                                            <b-btn
                                                variant="light"
                                                content="Add Row Before"
                                                v-tippy="{placement: 'top'}"
                                                class="menubar__button mt-1 mr-1 btn btn-sm"
                                                @click="commands.addRowBefore"
                                            >
                                                + Row Before
                                            </b-btn>
                                            <b-btn
                                                variant="light"
                                                content="Add Row After"
                                                v-tippy="{placement: 'top'}"
                                                class="menubar__button mt-1 mr-1 btn btn-sm"
                                                @click="commands.addRowAfter"
                                            >
                                                + Row After
                                            </b-btn>
                                            <b-btn
                                                variant="light"
                                                content="Delete Row"
                                                v-tippy="{placement: 'top'}"
                                                class="menubar__button mt-1 mr-1 btn btn-sm"
                                                @click="commands.deleteRow"
                                            >
                                                - Row
                                            </b-btn>
                                            <b-btn
                                                variant="light"
                                                content="Merge Row"
                                                class="menubar__button mt-1 mr-1 btn btn-sm"
                                                @click="commands.toggleCellMerge"
                                            >
                                                Merge Cells
                                            </b-btn>
                                        </div>
                                    </b-btn-group>

                                    <b-dropdown
                                        size="sm"
                                        variant="secondary"
                                        class="my-2"
                                        dropleft
                                    >
                                        <template #button-content>
                                            Cell Background
                                        </template>
                                        <b-input-group class="p-1" size="sm" style="postiion: relative; z-index: 100;">
                                            <b-form-input
                                                placeholder="Table Number"
                                                v-model="lesson_plan_table_number"
                                                style="max-width: 25%;"
                                            />
                                            <b-input-group-append>
                                                <b-button
                                                    variant="outline-success"
                                                    style="width: 100%;"
                                                >
                                                    Table Number
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                        <b-input-group class="p-1" size="sm">

                                            <b-form-input
                                                placeholder="Table Number"
                                                v-model="lesson_plan_row_number"
                                                style="max-width: 25%;"
                                            />
                                            <b-input-group-append>
                                                <b-button
                                                    variant="outline-success"
                                                    style="width: 100%;"
                                                >
                                                    Row Number
                                                </b-button>
                                            </b-input-group-append>

                                        </b-input-group>
                                        <b-input-group class="p-1" size="sm">

                                            <b-form-input
                                                placeholder="Table Number"
                                                v-model="lesson_plan_col_number"
                                                style="max-width: 25%;"
                                            />
                                            <b-input-group-append>
                                                <b-button
                                                    variant="outline-success"
                                                    style="width: 100%;"
                                                >
                                                    Col Number
                                                </b-button>
                                            </b-input-group-append>

                                            <b-form-group class="p-1 pt-3 text-center">
                                                <label>Background Color</label>
                                                <b-form-select
                                                    v-model="background_color"
                                                    :options="background_colors"
                                                ></b-form-select>
                                            </b-form-group>
                                            <b-btn
                                                variant="primary"
                                                content="Background Color"
                                                class="menubar__button mt-1 mr-1"
                                                @click="addBackgroundColor()"
                                            >
                                                Save
                                            </b-btn>
                                        </b-input-group>
                                    </b-dropdown>
                                </span>
                            </b-btn-group>

                        </div>
                        <div class="ml-auto">
                            <b-btn-group v-if="!isWalkthrough">
                                <b-btn
                                    variant="light"
                                    v-if="is_article_body"
                                    class="ml-2 pt-1"
                                    @click="$emit('show-changelog-modal')"
                                    content="Show Changelog"
                                    v-tippy="{placement: 'bottom'}"
                                >
                                    <font-awesome-icon
                                        :icon="['fas', 'history']"
                                        fixed-width
                                    />
                                </b-btn>
                                <b-btn
                                    v-if="!exclude_save"
                                    :variant="saving_content ? 'success' : 'light'"
                                    :class="{
                                        'active': saving_content,
                                        'article-log-state': updateType && updateType !== 'body_copied',
                                    }"
                                    content="Save Content"
                                    v-tippy="{
                                        placement: is_article_body ? 'bottom' : 'top'
                                    }"
                                    @click="saveContent"
                                    :disabled="saving_content"
                                >
                                    <span v-if="saving_content">
                                        <font-awesome-icon :icon="['fas', 'check']" fixed-width />
                                    </span>
                                    <span v-else>
                                        <font-awesome-icon :icon="['fad', 'save']" fixed-width />
                                    </span>
                                </b-btn>
                                <b-btn
                                    v-if="wordCount(value) > 0 && !exclude_copy"
                                    :variant="copying_to_clipboard ? 'success' : 'light'"
                                    :class="{
                                        'active': copying_to_clipboard,
                                        'article-log-state': updateType === 'body_copied',
                                    }"
                                    content="Copy to Clipboard"
                                    v-tippy="{
                                        placement: is_article_body ? 'bottom' : 'top'
                                    }"
                                    @click="copyToClipboard"
                                    :disabled="copying_to_clipboard"
                                >
                                    <span v-if="copying_to_clipboard">
                                        <font-awesome-icon :icon="['fas', 'check']" fixed-width />
                                    </span>
                                    <span v-else>
                                        <font-awesome-icon :icon="['fad', 'clipboard']" fixed-width />
                                    </span>
                                </b-btn>
                            </b-btn-group>
                        </div>
                    </div>
                </div>
            </editor-menu-bar>
        </div>

        <div style="max-height: 500px; overflow-y: auto;">
            <div v-if="editing_html">
                <prism-editor
                    v-model="html"
                    :code="html"
                    :insertSpaces="false"
                    language="html"
                    class="prism-editor border rounded"
                    :class="{'min-height': min_height}"
                    @blur="$emit('blur')"
                ></prism-editor>
            </div>
            <div v-else>
                <editor-content
                    ref="editor-content"
                    class="editor-content clearfix"
                    :class="{'readonly': readonly, 'min-height': min_height}"
                    :editor="editor"
                />
            </div>
        </div>

        <div class="d-flex align-items-center my-1" v-if="!hide_word_count">
            <div class="ml-auto">
                <small
                    class="text-nowrap text-muted"
                >
                    <span>word count:</span> <span :class="{'text-success': wordCount(value) > 0}">
                        <span v-if="wordCount(value) > 0">
                            {{wordCount(value)}}
                        </span>
                        <span v-else>
                            0
                        </span>
                    </span>
                </small>
            </div>
        </div>

        <add-related-media-modal
            v-model="show_add_related_media_modal"
            :type="'image'"
            @link="createSbpImgNode"
            @hide="show_add_related_media_modal = false"
        />

        <interactive-media-link-modal
            v-if="publication"
            v-model="show_interactive_media_link_modal"
            :article="article"
            :publication_id="publication.id"
            :panel="panel"
            @add="createInteractiveMediaLinkNode"
            @hide="show_interactive_media_link_modal = false"
        />
    </div>
</template>

<style lang="scss">
@import "@/assets/css/swo_lesson_plan_preview.scss";
.editor-content.min-height {
    .ProseMirror {
        min-height: 96px;
    }
}

.prism-editor.min-height {
    code[class*="language-"],
    pre[class*="language-"] {
        white-space: pre-wrap;
        font-family: inherit;
    }

    pre[class*="language-"] {
        padding: 0.375rem 0.75rem;
        min-height: 108px;
    }
}

</style>

<style lang="scss" scoped>
@import '@/assets/css/_colors';

.tiptap {
	&.is-invalid {
		.editor-content {
			border: 1px solid $danger;
		}
	}
	.menububble {
		position: absolute;
		display: -webkit-box;
		display: flex;
		z-index: 20;
		background: #000;
		border-radius: 5px;
		padding: .3rem;
		margin-bottom: .5rem;
		-webkit-transform: translateX(-50%);
		transform: translateX(-50%);
		visibility: hidden;
		opacity: 0;
		-webkit-transition: opacity .2s,visibility .2s;
		transition: opacity .2s,visibility .2s;
		&.active {
			opacity: 1;
			visibility: visible;
		}
	}
	.menububble__button {
		display: -webkit-inline-box;
		display: inline-flex;
		background: transparent;
		border: 0;
		color: #fff;
		padding: .2rem .5rem;
		margin-right: .2rem;
		border-radius: 3px;
		cursor: pointer;
		&.active {
			background-color: hsla(0, 0, 100%, .2);
		}
	}
}

.editor-content {
    &.form-control {
        padding: 0;
    }
}

@media (max-width: 767px) {
    .tiptap {
        .editor-menu-bar {
            .btn {
                padding: 0.25rem 0.5rem;
                font-size: 0.875rem;
                border-radius: 0.2rem;
            }
        }
    }
}

.btn-group {
    &.readonly {
        pointer-events: none;
    }
}

.editor-content {
    &.readonly {
        cursor: text;
        background-color: #e9ecef;
        border: 1px solid #ced4da;
        color: #495057;
    }
}

.article-log-state {
    background-color: rgb(52, 152, 219);
    color: white;
}
</style>

<script>
import copy from 'copy-html-to-clipboard'
import stripHtml from 'string-strip-html'

import { mapState } from 'vuex'

import { Editor, EditorContent, EditorMenuBar, EditorMenuBubble } from 'tiptap'

import MerlinImageNode from '@/common/tiptap/merlin-image-node'
import SbpImageNode from '@/common/tiptap/sbp-image-node'
import IframeNode from '@/common/tiptap/iframe-node'
import InteractiveMediaLinkNode from '@/common/tiptap/interactive-media-link-node'
import HighlightMark from '@/common/tiptap/highlight-mark'
import HighlightMarkOrange from '@/common/tiptap/highlight-mark-orange'
import HighlightMarkBlue from '@/common/tiptap/highlight-mark-blue'
import HighlightMarkGreen from '@/common/tiptap/highlight-mark-green'
import HighlightMarkBlack from '@/common/tiptap/highlight-mark-black'
import HighlightMarkWhite from '@/common/tiptap/highlight-mark-white'
import HighlightMarkTeal from '@/common/tiptap/highlight-mark-teal'
import HighlightMarkPink from '@/common/tiptap/highlight-mark-pink'
import HighlightMarkPurple from '@/common/tiptap/highlight-mark-purple'
import BlankNode from '@/common/tiptap/blank-node'
import CustomParagraph from '@/common/tiptap/custom-paragraph-node'
import HotTextCorrectNode from '@/common/tiptap/hot-text-correct-node'
import colors from '@/common/colors'
import { TextSelection } from 'prosemirror-state';
import { Fragment, Schema, Node } from 'prosemirror-model';

import {
    OrderedList,
    BulletList,
    ListItem,
    Bold,
    Image,
    Italic,
    Link,
    Strike,
    Underline,
    History,
    Table,
	TableHeader,
	TableCell,
	TableRow,
    HardBreak,
    HorizontalRule,
} from 'tiptap-extensions'

import SbpImageModal from '@/components/modals/media/SbpImageModal'
import AddRelatedMediaModal from '@/components/modals/article/related_media/AddRelatedMediaModal'
import InteractiveMediaLinkModal from '@/components/modals/article/interactive_media_link/InteractiveMediaLinkModal'
import {strip} from '@/common/questionsExporter/utility'

export default {
    data: () => ({
        editor: null,

        cached_value: {},

        editing_html: false,

        copying_to_clipboard: false,
        saving_content: false,

        pending_autosave: false,

        show_login_modal: false,
        show_sbp_image_modal: false,
        show_add_related_media_modal: false,
        show_interactive_media_link_modal: false,
        colors: colors,
        lesson_plan_table_number: 0,
        lesson_plan_row_number: 0,
        lesson_plan_col_number: 0,
        column_width: 'none',
        column_width_options: ['none', '10%', '25%', '33%', '50%', '66%', '75%', '90%'],
        background_color: 'none',
        background_colors: ['none', 'gray', 'orange', 'blue', 'green', 'red', 'yellow', 'teal', 'pink', 'purple'],
        border_color: 'gray',
        border_colors: ['gray', 'orange', 'blue', 'green', 'red'],
        border_styles: ['none', 'solid', 'dotted'],
        border_style: 'solid',
    }),
    props: {
        value: String,
        article: Object,
        publication: Object,
        panel: Object,
        menu_items: Array,
        menu_type: String,
        min_height: Boolean,
        readonly: Boolean,
        hide_word_count: Boolean,
        exclude_table: Boolean,
        exclude_table_resize: Boolean,
        exclude_save: Boolean,
        exclude_copy: Boolean,
        show_related_media_modal: {
            type: Boolean,
            default: false,
        },
        editable_content: Object,
        is_article_body: {
            type: Boolean,
            default: false,
        },
        stripTags: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        EditorContent,
        EditorMenuBar,
        EditorMenuBubble,
        SbpImageModal,
        InteractiveMediaLinkModal,
        AddRelatedMediaModal
    },
    computed: {
        ...mapState({

        }),
        html: {
            get () {
                let html = null

                html = this.value

                return html
            },
            set (html) {
                this.$emit('input', html)
            }
        },
        changes () {
            let changes = false

            if (
                // _.some(this.cached_value) &&
                !_.isEqual(this.cached_value, this.value)
            ) {
                changes = true
            }

            return changes
        },
        hasArticleData () {
            return typeof this.article !== 'undefined'
        },
        isWalkthrough () {
            if (this.hasArticleData) {
                return this.article.is_walkthrough;
            } else {
                return false;
            }
        },
        hotTextCorrectDisabled () {
            if(this.editable_content.options){
                let ht_disabled = false;
                let correct_count = 0;
                _.each(this.editable_content.options, option => {
                    console.log('option', option);
                });

                return ht_disabled;
            }
            else{
                return false;
            }
        },
        updateType() {
            if (this.is_article_body && this.article) {
                return this.$store.getters.latestLogTypeByArticleId(this.article.id)
            }

            return null
        },
    },
    watch: {
        readonly: {
            handler (readonly) {
                let editable = true

                if (readonly) {
                    editable = false
                }

                if (this.editor) {
                    this.editor.setOptions({
                        editable: editable
                    })
                }
            },
            immediate: true
        },

        show_related_media_modal: {
            handler(value) {
                if (value) {
                    this.show_add_related_media_modal = value;
                }
            }
        },
        show_sbp_image_modal: {
            handler(value){
                if(!value) this.$emit('closedImageModal');
            }
        },
        show_add_related_media_modal: {
            handler(value){
                if (value) this.addSbpImage()
                if(!value) {
                    this.$emit('closedImageModal');
                    this.$emit('closeSbpModal')
                }
            }
        }
    },
    methods: {
        alignParagraph(alignment) {
            console.log('alignment', alignment);
            this.editor.commands.align(alignment); // Calls the custom alignment command
        },
        addSbpImage(){
            this.show_sbp_image_modal = true
            this.show_add_related_media_modal = true
        },
        createSbpImgNode (asset, width, align) {

            let relatedmediaid = null
            let caption = null
            let credit = null
            let description = null
            let src = null
            let alt = null

            if (asset.id) {
                relatedmediaid = asset.id
            }

            if (asset.caption) {
                caption = asset.caption
            }

            if (asset.credit) {
                credit = asset.credit
            }

            if (asset.description) {
                description = asset.description
            }
            if (asset.alt) {
                alt = asset.alt
            }
            if (asset.url) {
                src = asset.url
            }

            if (width) {
                width = width + '%'
            }

            this.editor.commands.sbp_image_node({
                relatedmediaid: relatedmediaid,
                align: align,
                alt: alt,
                caption: caption,
                credit: credit,
                description: description,
                src: src,
                width: width,
                customClass: 'sbp_image sbp_image_'+align,
            })

            this.$emit('update')

            this.show_sbp_image_modal = false
            this.show_add_related_media_modal = false
        },
        addInteractiveMediaLink () {
            this.show_interactive_media_link_modal = true
        },
        createInteractiveMediaLinkNode (item, type) {
            this.editor.commands.interactive_media_link_node({
                id: item.id,
                dam_id: item.dam_id,
                type: type,
                title: item.title,
                media_type: item.type
            })

            this.$emit('update')

            this.show_interactive_media_link_modal = false
        },
        editHTML () {
            if (this.editing_html) {
                this.editing_html = false

                if (this.html) {
                    this.editor.setContent(this.html)
                }
            } else {
                this.editing_html = true
            }
        },
        autosave: _.debounce(function (value) {
            if (this.pending_autosave) {
                this.$emit('update')

                this.cached_value = _.cloneDeep(value)

                this.pending_autosave = false
            }
        }, 3000),
        copyToClipboard() {
            this.$emit('clipboard-copy')

            let value = null

            if (this.value) {
                value = this.value

                // remove all tags
                if (this.stripTags) {
                    value = strip(value)
                    copy(value, {
                        asHtml: false,
                    })
                } else {
                    copy(value, {
                        asHtml: true
                    })
                }

                this.copying_to_clipboard = true

                setTimeout(() => {
                    this.copying_to_clipboard = false
                }, 1500)
            }
        },
        saveContent() {
            this.saving_content = true
            this.$emit('save')

            setTimeout(() => {
                this.saving_content = false
            }, 1500)
        },
        wordCount (string) {
            let words = null

            if (string) {
                words = stripHtml(string).result

                words = words.split(' ').filter((n) => { return n != '' }).length
            }

            return words
        },
        addBlank () {
            // let blank_id = Math.floor(Math.random() * 100000)

            let blank_id = null

            if (!this.editable_content.blanks) {
                this.$set(this.editable_content, 'blanks', [])
            }

            blank_id = this.editable_content.blanks.length + 1

            const { selection, state } = this.editor
            const { from, to } = selection

            this.selected_text = state.doc.textBetween(from, to, ' ')

            this.editor.commands.blank_node({
                blank_id: blank_id,
                answer: this.selected_text,
                class: 'blank'
            })

            this.$emit('addBlank', blank_id, this.selected_text)
        },
        addBackgroundColor(){
            let table_number = this.lesson_plan_table_number;
            let row = this.lesson_plan_row_number;
            let col = this.lesson_plan_col_number;
            let background_style = "";
            let width_style = "";
            let start_style = 'style=" ';
            let end_style = ' "';

            if(this.background_color != 'none'){
                background_style = this.colors.getBackgroundColor(this.background_color);
            }

            if(this.column_width != 'none'){
                width_style = ' width="'+this.column_width+'" ';
            }

            let new_style = start_style+background_style+end_style+width_style;
            let updated_table = "";
            let doctored_string = "";
            const live_html = this.editor && this.editor.getHTML ? this.editor.getHTML() : this.html;
            let original_text = '!@#' + live_html;
            let split_on_tables = original_text.split('<table');

            let table_count = 0;
            _.each(split_on_tables, table => {
                if(table_count == table_number){
                    if(table_count > 0){
                        updated_table = updated_table + '<table';
                    }
                    let split_on_rows = table.split('<tr');
                    let row_count = 0;
                    _.each(split_on_rows, row_string => {
                        if(row_count == row){
                            updated_table = updated_table + '<tr>';
                            let split_on_columns = row_string.split('<td');
                            let column_count = 0;
                            _.each(split_on_columns, column_string => {
                                if(column_count == col){
                                    //remove style if it exists already
                                    if(column_string.includes('style="')){
                                        let regex = /\s*style="[^"]*"/i;
                                        column_string = column_string.replace(regex, '');
                                        console.log('column_string 2', column_string);
                                        updated_table = updated_table + '<td ' + new_style + column_string;
                                    }
                                    else{
                                        //add td back with style
                                        updated_table = updated_table + '<td '+ new_style + column_string;
                                    }
                                }
                                else{
                                    //add td back
                                    if(column_count > 0){
                                        updated_table = updated_table + '<td' + column_string;
                                    }
                                }
                                column_count++;
                            });
                        }
                        else{//add tr tag back
                            if(row_count > 0){
                                updated_table = updated_table + '<tr' + row_string;
                            }
                            else{
                                updated_table = updated_table + row_string;
                            }
                        }
                        row_count++;

                    })
                    doctored_string = doctored_string + updated_table;
                }
                else{//add table tag back
                    if(table_count > 0){
                        doctored_string = doctored_string + '<table' + table;
                    }
                    else{
                        doctored_string = doctored_string + table;
                    }
                }
                table_count ++;
            });
            //remove added substring from front of the doctored string
            doctored_string = doctored_string.slice(3);

            this.editor.setContent(doctored_string);
            this.$emit('input', doctored_string);
            this.$emit('update_tiptap_table', doctored_string);

            //reset form
            this.lesson_plan_table_number = 0;
            this.lesson_plan_row_number = 0;
            this.lesson_plan_col_number = 0;
            this.background_color = 'none';
        },
        getIndexOfNthOccurrence(str, subStr, n) {
            let count = 0;
            let pos = str.indexOf(subStr);

            while (pos !== -1) {
                count++;
                if (count === n) {
                    console.log('found it', pos);
                return pos;
                }
                pos = str.indexOf(subStr, pos + 1);
            }

            return -1; // Return -1 if the nth occurrence is not found
        },
        findCursorPositionInHTMLString(){
            const { selection, state } = this.editor;
            const { from, to } = selection;
            const plainText = this.editor.state.doc.textContent;
            const selectedText = state.doc.textBetween(from, to, ' ');
            const textToInsert = 'Inserted Text';

            this.insertText(textToInsert);

            // Use the command to insert the text at the current selection
            this.editor.commands.insertText(textToInsert);

            let text_array = this.html.split('');
            let tag_text = 0;
            let add = false;
            let text_index = 0;
            let non_tag_text = 0;
            let updated_from = this.html.length;
            //Loop over every charachter in the html string
            _.each(text_array, text_char => {

                if(text_char == '<'){
                    tag_text++;
                    add =true;
                }
                else if(text_char == '>'){
                    tag_text++;
                    add =false;
                }
                else{
                    if(add){
                        tag_text++;
                    }
                    else{
                        non_tag_text++;
                    }
                }
                if(non_tag_text == from){
                    updated_from = text_index;
                }
                text_index++;

            });

            return {
                updated_from: updated_from,
            };
        },
        insertText(html) {
            const { state, view } = this.editor;
            const { from, to } = state.selection;

            // Convert the HTML string to a ProseMirror node
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html').body;

            // Create a Fragment from the HTML
            const fragment = schema.nodeFromJSON({
                type: 'doc',
                content: [{ type: 'paragraph', content: [{ type: 'text', text: doc.textContent }] }]
            });

            // Create a transaction to replace the selection with the new content
            let transaction = state.tr.replaceSelectionWith(fragment, true);

            // Apply the transaction to the view
            view.dispatch(transaction);

            // Set the new selection after the inserted content
            const newPos = from + fragment.nodeSize;
            if (newPos <= transaction.doc.content.size) {
                const newSelection = TextSelection.create(transaction.doc, newPos);
                transaction = transaction.setSelection(newSelection);
                view.dispatch(transaction);
            }
        },
        allow_center_image (table_is_active) {
           return table_is_active;
        },
        addHorizontalRule() {
            this.editor.commands.horizontal_rule();
        },
        addHotText(correct){
            let hot_text_id = null;
            let hot_text_class = 'hot_text_correct';
            let style = 'background-color: lightgreen';
            if(!correct){
                hot_text_class = 'hot_text_incorrect';
                style = 'background-color: pink';
            }

            if (!this.editable_content.options) {
                this.$set(this.editable_content, 'options', [])
            }

            hot_text_id = 1;
            _.each(this.editable_content.options, option => {
                let currentId = Number(option.hot_text_id);
                if(currentId >= hot_text_id){
                    hot_text_id = currentId + 1;
                }
            });

            const { selection, state } = this.editor
            const { from, to } = selection

            this.selected_text = state.doc.textBetween(from, to, ' ')

            let hot_text_obj = Object.freeze({
                hot_text_id: hot_text_id,
                selected_text: this.selected_text,
                hot_text_class: hot_text_class,
                correct: correct,
                style: style,
            });
            this.editable_content.options.push(_.cloneDeep(hot_text_obj));
            this.editor.commands.hot_text_node(hot_text_obj);
        },
    },
    mounted () {
        let readonly = true

        if (this.readonly) {
            readonly = false
        }

        const pasteHighlighterMenuKeys = [
            'highlight',
            'highlight_black',
            'highlight_blue',
            'highlight_green',
            'highlight_orange',
            'highlight_pink',
            'highlight_purple',
            'highlight_teal',
            'highlight_white',
        ]

        const vm = this

        this.editor = new Editor({
            editorProps: {
                transformPastedHTML (pastedHtml) {
                    const menuHasHighlighters = (item) => vm.menu_items && vm.menu_items.includes(item)
                    const highlighters = pasteHighlighterMenuKeys.filter(menuHasHighlighters)
                    const canChangeColors = highlighters.length > 0
                    if (canChangeColors) {
                        return pastedHtml
                    }

                    const parsedElement = new DOMParser().parseFromString(pastedHtml, 'text/html')
                    parsedElement.querySelectorAll('[style]').forEach((element) => {
                        element.style.removeProperty('color')
                    })

                    return parsedElement.body.innerHTML
                },
            },
            extensions: [
                new BlankNode(),
                new HotTextCorrectNode(),
                new Link(),
                new BulletList(),
                new OrderedList(),
                new ListItem(),
                new Bold(),
                new Image(),
                new Italic(),
                new Strike(),
                new Underline(),
                new History(),
                new Table({
                    resizable: !this.exclude_table_resize,
                }),
                new TableHeader(),
                new TableCell(),
                new TableRow(),
                new InteractiveMediaLinkNode(),
                new HighlightMark(),
                new HighlightMarkOrange(),
                new HighlightMarkBlue(),
                new HighlightMarkGreen(),
                new HighlightMarkBlack(),
                new HighlightMarkWhite(),
                new HighlightMarkTeal(),
                new HighlightMarkPink(),
                new HighlightMarkPurple(),
                new CustomParagraph(),
                new MerlinImageNode(),
                new SbpImageNode(),
                new IframeNode(),
                new HardBreak(),
                new HorizontalRule(),

            ],
            editable: readonly,
            onUpdate: (value) => {
                let html = null

                if (value) {
                    html = value.getHTML()
                }

                if (html === '<p></p>') {
                    html = ''
                }

                this.$emit('input', html)
            },
            onBlur: () => {
                if (this.changes) {
                    this.$emit('blur')
                }

                this.pending_autosave = false

                this.cached_value = _.cloneDeep(this.value)
            }
        })

        if (this.value) {
            this.editor.setContent(this.value)

            this.cached_value = _.cloneDeep(this.value)
        }
    },
    beforeDestroy () {
        if (this.editor) {
            this.editor.destroy()
        }
    }
}
</script>
